import { useAppSelector } from "hooks/storeHooks"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { IntegrationType } from "types"
import { AddProductCard } from "./AddProductCard"
import { FileSpreadsheet, PenLine, Store } from "lucide-react"

interface AddProductStepOneProps {
  handleGoToStepTwo: (type?: string) => void
}

export const AddProductStepOne: React.FC<AddProductStepOneProps> = ({ handleGoToStepTwo }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const userType = useAppSelector((state) => state.user.userInfo.integrationType)

  if (userType === IntegrationType.COMMON)
    return (
      <div className="flex flex-col gap-3 pt-2" data-testid="add-product-step-one">
        <AddProductCard
          testId="add-product-manual"
          variant="primary"
          badge={t("addProductStepOne.recommendedBadge")}
          icon={<PenLine className="h-5 w-5" />}
          title={t("addProductStepOne.manualTitle")}
          description={t("addProductStepOne.manualDescription")}
          onClick={() => navigate("/products/add")}
        />
        <AddProductCard
          testId="add-product-bulk"
          icon={<FileSpreadsheet className="h-5 w-5" />}
          title={t("addProductStepOne.bulkTitle")}
          description={t("addProductStepOne.bulkDescription")}
          onClick={() => handleGoToStepTwo("bulk")}
        />
      </div>
    )

  return (
    <div className="flex flex-col gap-3 pt-2" data-testid="add-product-step-one">
      <AddProductCard
        testId="add-product-from-store"
        icon={<Store className="h-5 w-5" />}
        title={t("addProductStepOne.storeTitle")}
        description={t("addProductStepOne.storeDescription")}
        onClick={() => handleGoToStepTwo("from-store")}
      />
    </div>
  )
}
